export default "__VITE_ASSET__DpCboW60__"